import styled from 'styled-components'

import theme from 'style/theme'

export default styled.div`
  .ant-collapse-item {
    border-bottom: 1px solid #e0e0e0;
    .ant-collapse-arrow {
      svg {
        font-size: 14px;

        fill: ${theme.darkGray};
      }
    }
    .header-custom {
      display: flex;
      align-items: center;
      .header-icon {
        background-image: linear-gradient(103deg, #e82727 -36%, #ff8456 99%);
        padding: 5px;
        font-size: 25px;
        margin-right: 8px;
        border-radius: 8px;
        text-align: center;
        display: flex;
        justify-content: center;
        svg {
          font-size: 16px;
          color: ${theme.white};
        }
      }
      .ant-typography {
        font-size: 20px;
        color: ${theme.darkGray};
        margin-bottom: 0;
      }
    }
  }
`
